"use strict";import{tag as t}from"../custom-tag.js";export function forward15Icon({height:r=16,width:l=16,hidden:e=!1,title:a="Forward 15"}={}){return t`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${r}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${e?"true":"false"}"
      role="img"
      aria-label="${a}"
    >
      <mask
        id="forward-15_svg__mask0_6875_6788"
        width="20"
        height="17"
        x="2"
        y="4"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="m15.388 4 4.958 2.863-4.958 2.862V7.36H7.206a4.215 4.215 0 0 0 0 8.429h.529v.991h-.529a5.206 5.206 0 1 1 0-10.412h8.182z"
          clip-rule="evenodd"
        />
        <path
          fill="currentColor"
          d="M13.638 19.839H12.6v-6.545l-1.712.883v-1.08l1.723-.894h1.026zm2.897-1.855h1.113q.12.534.567.84.426.295 1.047.295.774 0 1.244-.535.414-.48.414-1.265 0-.885-.513-1.342-.425-.393-1.123-.393-.938 0-1.527.698h-.928l.164-4.08h4.69v.884h-3.74l-.088 2.236q.698-.556 1.669-.556 1.134 0 1.822.742.654.709.654 1.854 0 1.19-.818 1.942-.753.698-1.93.698-1.19 0-1.975-.698a2.23 2.23 0 0 1-.742-1.32"
        />
      </mask>
      <g mask="url(#forward-15_svg__mask0_6875_6788)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=forward15.js.map
